// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 937 ? "eabe11fc" : chunkId) + "." + {"167":"4eafd7369ac6b5f1","651":"9078e83f25d7ee7c","741":"cd9485d61f910928","937":"9a32cf2139072bf3"}[chunkId] + ".js";
};